import React, { Component } from "react";
import '../features.css';

const deals = [
  {
    img: "img/black-lake-logo.png",
    name: "Black Lake Golf Club",
    tag: "Twosome 2024",
    href: "https://lessongolf.myshopify.com/collections/frontpage/products/black-lake-golf-club-twosome-2024",
    fit: true,
  },
  {
    img: "img/shanty.png",
    name: "Cedar River Golf Club",
    tag: "Twosome 2024",
    href: "https://lessongolf.myshopify.com/collections/frontpage/products/cedar-river-golf-club-at-shanty-creek-twosome-2024",
  },
  {
    img: "img/cattails.jpg",
    name: "Cattails Golf Club",
    tag: "Twosome 2024",
    href: "https://lessongolf.myshopify.com/collections/frontpage/products/cattails-golf-club-twosome-2024",
  },
  {
    img: "img/hidden-river.png",
    name: "Hidden River Golf Club",
    tag: "Twosome 2024",
    href: "https://lessongolf.myshopify.com/collections/frontpage/products/hidden-river-golf-club-2024-twosome-not-valid-weekends-before-11am",
  },
  {
    img: "img/hilltop.png",
    name: "Hilltop Golf Course",
    tag: "Twosome 2024",
    href: "https://lessongolf.myshopify.com/collections/frontpage/products/hilltop-golf-course-twosome-2024",
    fit: true,
  },
  {
    img: "img/moose.jpg",
    name: "Moose Ridge Golf Course",
    tag: "Twosome 2024",
    href: "https://lessongolf.myshopify.com/collections/frontpage/products/moose-ridge-golf-course-no-holidays-twosome-2024",
    fit: true,
  },
];

export class features extends Component {
  render() {
    return (
      <div id="features" className="text-center">
        <div className="container">
          <div className="feature-title">
            <h2>Featured Deals</h2>
            <h4 className="discounts">NO MORE ADDED FEES!</h4>
            <div className="title-underline"></div>
          </div>

          <div className="deals-grid">
            {deals.map((d) => (
              <div className="deal-card" key={d.name}>
                <div className="deal-img-wrap">
                  <img
                    src={d.img}
                    className={`course ${d.fit ? 'fit-img' : ''}`}
                    alt={d.name}
                  />
                </div>
                <h3 className="deal-name">{d.name}</h3>
                <h4 className="discounts">{d.tag}</h4>
                <a
                  href={d.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-custom btn-lg deal-btn"
                >
                  View Deal
                </a>
              </div>
            ))}
          </div>

          <div className="deals-footer">
            <a
              href="https://lessongolf.myshopify.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-custom btn-lg shop-btn-features"
            >
              View All Deals
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default features;
